// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title{display:table;background:var(--grey-ultra-light);width:100%}.page-title .logo{width:50px;height:50px;display:table-cell;vertical-align:middle;float:none;padding:var(--space-10) var(--space-6) var(--space-10) 0}@media (min-width: 970px){.page-title .logo{float:left;margin-left:-120px}}.page-title h1{display:table-cell;vertical-align:middle;padding-top:var(--space-10);padding-bottom:var(--space-10);text-align:center;line-height:var(--line-height-48)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
